var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-card", [
    _vm.isExpanded == false
      ? _c(
          "div",
          { staticClass: "text-center" },
          [
            _c(
              "b-button",
              {
                on: {
                  click: function ($event) {
                    _vm.isExpanded = true
                  },
                },
              },
              [_vm._v("Request a Deposit")]
            ),
          ],
          1
        )
      : _c(
          "div",
          [
            _c(
              "b-form-group",
              { attrs: { label: "Deposit Payment" } },
              [
                _c("b-form-radio-group", {
                  staticClass: "mt-2",
                  attrs: { name: "deposit-amount", options: _vm.options },
                  model: {
                    value: _vm.fullAmount,
                    callback: function ($$v) {
                      _vm.fullAmount = $$v
                    },
                    expression: "fullAmount",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "deposit-amount mt-4" },
                  [
                    _c("span", [_vm._v("Deposit Amount:")]),
                    _vm._v(" "),
                    !_vm.fullAmount
                      ? _c("currency-input", {
                          attrs: {
                            name: "Deposit Amount",
                            size: 12,
                            amount: _vm.depositAmount,
                            fieldState: _vm.fieldState.amount,
                          },
                          on: {
                            "update:amount": function ($event) {
                              _vm.depositAmount = $event
                            },
                          },
                        })
                      : _c("span", { staticClass: "ml-3" }, [
                          _vm._v(
                            _vm._s(_vm.getVendor.local_currency) +
                              _vm._s(_vm.prettyBalance)
                          ),
                        ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "copy-link" },
              [
                _c("b-form-input", {
                  attrs: { readonly: "", value: _vm.linkUrl },
                }),
                _vm._v(" "),
                _c(
                  "b-btn",
                  {
                    directives: [
                      {
                        name: "clipboard",
                        rawName: "v-clipboard:copy",
                        value: _vm.linkUrl,
                        expression: "linkUrl",
                        arg: "copy",
                      },
                      {
                        name: "clipboard",
                        rawName: "v-clipboard:success",
                        value: _vm.onCopy,
                        expression: "onCopy",
                        arg: "success",
                      },
                      {
                        name: "clipboard",
                        rawName: "v-clipboard:error",
                        value: _vm.onError,
                        expression: "onError",
                        arg: "error",
                      },
                    ],
                  },
                  [_c("i", { staticClass: "fi fi-clipboard-pencil" })]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("br"),
            _c("br"),
            _vm._v(" "),
            _c(
              "b-button",
              {
                on: {
                  click: function ($event) {
                    _vm.isExpanded = false
                  },
                },
              },
              [_vm._v(" Done ")]
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }